import { Docx as DocxStructure } from "../structure";
import JSZip from "jszip";

/**
 * ZIP
 */
class Zip {
    /**
     * Opens a DOCX
     *
     * @param source - Source DOCX
     * @returns Promise DocxStructure
     * @throws Error reading DOCX file
     */
    public async open(source: ArrayBuffer): Promise<DocxStructure> {
        const jszip = new JSZip();
        const docxTemplateStructure = new DocxStructure();

        try {
            const documentZip = await jszip.loadAsync(source);

            for (const keyZip in documentZip.files) {
                if (keyZip.endsWith(".xml") || keyZip.endsWith(".rels")) {
                    // text contents
                    const fileValue = await documentZip
                        .file(keyZip)
                        ?.async("string")
                        .then(fileData => fileData);
                    if (fileValue != null) {
                        docxTemplateStructure.addTextContent(keyZip, fileValue);
                    }
                } else {
                    // other contents
                    const fileValue = await documentZip
                        .file(keyZip)
                        ?.async("uint8array")
                        .then(fileData => fileData);
                    if (fileValue != null) {
                        docxTemplateStructure.addFileContent(keyZip, fileValue);
                    }
                }
            }
        } catch (err) {
            throw new Error("Error reading DOCX contents: " + err);
        }

        return docxTemplateStructure;
    }

    /**
     * Saves a DOCX
     *
     * @param docxStructure - DOCX Structure
     * @returns Promise ArrayBuffer
     */
    public async generateArrayBuffer(
        docxStructure: DocxStructure
    ): Promise<ArrayBuffer> {
        const jszip = new JSZip();

        // add text contents
        for (const [filePath, fileContent] of docxStructure
            .getTextContents()
            .entries()) {
            jszip.file(filePath, fileContent);
        }
        // add file contents
        for (const [filePath, fileContent] of docxStructure
            .getFileContents()
            .entries()) {
            jszip.file(filePath, fileContent);
        }

        const newZip = await jszip.generateAsync({
            type: "arraybuffer",
            mimeType:
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            compression: "DEFLATE",
        });

        return newZip;
    }
}

export { Zip };
